// extracted by mini-css-extract-plugin
export default {"tasksWrapper":"VkShareTask_tasksWrapper__5N57e"};